<template>
  <!-- 根据是否有宽度值，动态设置div的宽度，如果width为空，则宽度为100% -->
  <div :style="{'width': aqUtil.string.vIfEmptyToStr(width+'px','100%')}">
    <!-- 当文本内容超出预设的行数时，显示带有tooltip的文本容器 -->
    <el-tooltip v-if="isOverflowing" placement="top">
      <!-- tooltip内容，限制最大宽度为300px -->
      <div slot="content" style="max-width: 300px">
        <div>
          {{ content }} <!-- 显示文本内容 -->
        </div>
      </div>
      <!-- 文本容器，通过id和ref标识，应用text-container样式 -->
      <div ref="textContainer" class="text-container">
        {{ content }} <!-- 显示文本内容 -->
      </div>
    </el-tooltip>
    <!-- 当文本内容未超出预设行数时，直接显示文本 -->
    <div v-else>
      {{ content }} <!-- 显示文本内容 -->
    </div>
  </div>
</template>

<script>

import {utils} from "@/util/utils";

export default {
  name: "LineOverflowTemp",
  computed: {
    aqUtil() {
      return utils
    }
  },
  // 组件名称
  methods: {
    autoCalc() {
      this.$nextTick(() => {
        if (this.$refs.textContainer) {
          this.$refs.textContainer.style.webkitLineClamp = this.maxLines.toString();
          this.isOverflowing = this.$refs.textContainer.scrollHeight > this.$refs.textContainer.clientHeight;
        }
      });
    }
  }, // 组件方法，引入两个自定义函数
  props: { // 定义组件接收的props
    content: { // 文本内容，非必需
      type: String,
      required: false
    },
    maxLines: { // 最大行数，默认为2
      type: Number,
      default: 2
    },
    width: Number, // 文本容器宽度
  },
  data() { // 组件的本地状态
    return {
      isOverflowing: true // 默认假设内容溢出，需要后续在mounted钩子中验证
    };
  },
  watch: {
    content() {
      this.autoCalc();
    },
  },

  mounted() { // 组件挂载后的逻辑
    this.autoCalc();
  }
};
</script>


<style scoped>
.text-container {
  overflow: hidden; /* 隐藏溢出的内容 */
  display: -webkit-box; /* 使用弹性盒子模型显示内容 */
  -webkit-box-orient: vertical; /* 设置盒子的布局方向为垂直 */
  position: relative; /* 设置相对定位，为tooltip定位提供参考 */
  width: inherit;
  word-break: break-all;
}

.text-container .tooltip {
  display: none; /* 默认不显示tooltip */
  position: absolute; /* 绝对定位 */
  top: 100%; /* 定位到容器的底部 */
  left: 50%; /* 定位到容器的中心 */
  transform: translateX(-50%); /* 确保tooltip水平居中显示 */
  background-color: #333; /* tooltip背景色 */
  color: #fff; /* 文本颜色 */
  padding: 5px 10px; /* 内边距 */
  border-radius: 4px; /* 边框圆角 */
  white-space: nowrap; /* 不换行 */
  z-index: 1000; /* z-index设置为1000，确保在顶层显示 */
}
</style>
